import React from 'react'
import { faGithub, faInstagram, faLinkedin, faTelegram } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


const Footer = () => {
    return (
        <footer class="bg-blue-500">
            <div id="02" class="max-w-7xl mx-auto py-12 px-4 pt-4 overflow-hidden sm:px-6 lg:px-8">
                <div class="mt-8 flex justify-center space-x-6">
                    <a href="https://www.linkedin.com/in/visto-kartika-715a191b8/" class="text-white hover:text-gray-400 transition duration-300">
                        <span class="sr-only">Linked In</span>
                        <FontAwesomeIcon icon={faLinkedin} className="text-2xl mr-1"/>
                    </a>

                    <a href="https://github.com/vistokartika" class="text-white hover:text-gray-400 transition duration-300">
                        <span class="sr-only">GitHub</span>
                        <FontAwesomeIcon icon={faGithub} className="text-2xl"/>
                    </a>
                </div>
                <p class="justify-center flex mt-8 text-center text-base text-white">
                Made by 
                <a href="https://www.linkedin.com/in/visto-kartika-715a191b8/" className="ml-1 hover:text-gray-400 transition duration-300">Benedictus Visto Kartika</a>
                </p>
            </div>
        </footer>
    )
}

export default Footer
